// Core components
import { Component, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { MatDialog, MatInput } from '@angular/material';

// Third party components
import { FieldType } from '@ngx-formly/material';
import { take } from 'rxjs/operators';

// Custom components
import { ManualAddressDialogComponent } from 'src/app/shared/components/dialogs/manual-address-dialog/manual-address-dialog.component';
import { HelperService } from 'src/app/shared/services/helper.service';

@Component({
  selector: 'app-formly-address-type',
  template: `
    <input matInput class="d-none"
      [formControl]="formControl">
    <input matInput 
      [formControl]="formControl2"
      [formlyAttributes]="field"
      [placeholder]="to.placeholder"
      (click)="onClick()"
      (keydown)="onClick()" >
  `,
})
export class AddressTypeComponent extends FieldType implements OnInit, OnChanges, OnDestroy {
  @ViewChild(MatInput, { static: false }) formFieldControl: MatInput;
  formControl2: AbstractControl = new FormControl();

  constructor(
    private helperService: HelperService,
    private dialog: MatDialog,
  ) {
    super();
  }

  /**
   * Init component
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
    super.ngOnInit();

    if (this.to.disabled) {
      this.formControl2.disable();
    }

    if (this.formControl.value) {
      this.formControl2.setValue(this.helperService.getFormattedAddress(this.formControl.value));
    }
  }

  /**
   * After view init logic
   *
   * @since 1.0.0
   */
  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

   /**
   * Listen for @Input changes
   *
   * @since 1.0.0
   */
   ngOnChanges(): void {
    if (this.formControl.value) {
      this.formControl2.setValue(this.helperService.getFormattedAddress(this.formControl.value));
    }
  }

  /**
   * Handle component destroy
   *
   * @since 1.0.0
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
  }

  /**
   * Open a new dialog used to let user manually fill address
   * data and save that data
   *
   * @since 1.0.0
   */
  openManualAddressDialog(googleRes?: any): void {
    const addressData: any = {};
    if (googleRes) {
      addressData.route = googleRes.route;
      addressData.streetNumber = googleRes.streetNumber;
      addressData.postalCode = googleRes.postalCode;
      addressData.city = googleRes.city;
      addressData.administrativeArea1 = googleRes.administrativeArea1;
      addressData.administrativeArea2 = googleRes.administrativeArea2;
      addressData.administrativeArea3 = googleRes.administrativeArea3;
      addressData.countryCodeTwo = googleRes.countryCodeTwo;
      addressData.latitude = googleRes.latitude;
      addressData.longitude = googleRes.longitude;
    }
    // @todo completare
    const dialogRef = this.dialog.open(ManualAddressDialogComponent, {
      data: {
        ...addressData,
        required: this.to.required
      },
      width: '600px',
      autoFocus: false,
    });
    // Subscribe to dialog result (only for 1 emit thanks to "take()")
    dialogRef.beforeClosed()
      .pipe(
        take(1)
      )
      .subscribe(
        res2 => {
          if (typeof res2 !== 'undefined') {
            const formattedAddress = this.helperService.getFormattedAddress(res2);
            this.formControl.setValue(res2);
            this.formControl2.setValue(formattedAddress);
          }
        }
      );
  }

  /**
   * Once formControl2 has been clicked just make the label
   * float
   *
   * @todo this cause label to float even once user click in
   * some other field and it's not good. Would be nice to find
   * a way to make label disappear once user defocus the input
   *
   * @since 1.0.0
   */
  onClick(): void {
    this.formField.floatLabel = 'always';

    this.openManualAddressDialog(this.formControl.value);
  }
}
